import { RESIZE_CUSTOM } from "./resize-detection";

export function fox_doctrine_table() {
	const pathname = window.location.pathname;
	if (!pathname.includes("FoxDoctrineBooks")) return;

	const applyMobileBodyMargin = () => {
		const isMobile = document.body.classList.contains("mobile");
		if (isMobile) {
			document.body.style.margin = "8px";
		} else {
			// Important: remove the inline margin so desktop/tablet can follow CSS/legacy page styles.
			document.body.style.removeProperty("margin");
		}
	};

	// Apply immediately and keep in sync when resize-detection toggles .mobile/.desktop.
	applyMobileBodyMargin();
	if (document.body.dataset.foxDoctrineMarginBound !== "true") {
		document.body.dataset.foxDoctrineMarginBound = "true";
		window.addEventListener(RESIZE_CUSTOM, applyMobileBodyMargin);
	}

	setTimeout(onresize, 10);

	function onresize() {
		const isMobile = !!document.body.classList.contains("mobile");
		if (!isMobile) return;

		let originalSections = Array.from(document.querySelectorAll("table th"));
		// need to reorganize the elements;
		originalSections = originalSections.flatMap((s) => {
			const title = Array.from(s.querySelectorAll("p")).find((p) => {
				return (p.textContent?.trim().length ?? 0) > 0;
			});
			if (title?.textContent?.trim().includes("Volume 4")) {
				const doctrine4Title = title;
				// for doctrive4 find the attached book5;
				const children = Array.from(
					title.parentElement?.querySelector("ul")?.children ?? [],
				);
				const idx = children.findIndex((el) => {
					return el.querySelector("a")?.href.endsWith("Doctrine2.pdf");
				});

				const doctrine4Comments = Array.from(
					doctrine4Title.parentElement?.querySelector("ul")?.children ?? [],
				);

				// create doctrine5
				const th = document.createElement("th");
				const doctrine5Contents = doctrine4Comments.slice(idx) as HTMLElement[];
				th.classList.add("doctrine5");
				const ulComments = document.createElement("ul");
				doctrine5Contents.slice(2).forEach((el) => ulComments.append(el));
				ulComments.classList.add("comments");

				th.append(doctrine5Contents[0]);

				// swap span to P
				const p = document.createElement("p");
				p.innerHTML = doctrine5Contents[1].innerHTML;
				p.setAttribute("align", "center");
				doctrine5Contents[1] = p;

				th.append(doctrine5Contents[1]);
				console.log("dictrine5", doctrine5Contents);
				th.append(ulComments);

				doctrine4Title.parentElement?.insertAdjacentElement("afterend", th);

				// fix doctrine4
				const doctrine4Ul = title.parentElement?.querySelector("ul");
				const doctrine4Contents = doctrine4Comments.slice(0, idx);
				if (doctrine4Ul) {
					doctrine4Ul.innerHTML = ""; //first empty it
					doctrine4Contents.forEach((el) => doctrine4Ul.append(el));
				}

				return [doctrine4Title.parentElement!, th];
			}

			return s;
		});

		const divTable = document.createElement("div");
		// divTable.style.backgroundColor = "#FFFFCC";
		divTable.style.borderCollapse = "collapse";

		originalSections.forEach((temp) => {
			const content = temp.innerHTML;
			const d = document.createElement("div");
			d.innerHTML = content;
			d.querySelector("ul")?.classList.add("accordion-content");
			divTable.append(d);

			const title = Array.from(d.querySelectorAll("p")).find((p) => {
				return (p.textContent?.trim().length ?? 0) > 0;
			});

			if (!title || (title.textContent?.length ?? 0) <= 0) return;
			let isShown = true;

			// make accordion
			const id = Math.random().toString();
			const label = document.createElement("label");

			const input = document.createElement("input");
			input.id = id;
			input.type = "checkbox";
			input.className = "accordion-toggle";
			input.checked = isShown;

			label.setAttribute("for", id);
			label.setAttribute("align", title.getAttribute("align") ?? "");
			label.classList.add("accordion-label");
			label.style.display = "flex";
			label.style.justifyContent = "center";

			const parentElement = title.parentElement;
			parentElement?.replaceChild(label, title);
			parentElement?.insertBefore(input, label);

			const hideMessage = title.innerHTML + "&#9650";
			const showMessage = title.innerHTML + "&#9660";

			label.innerHTML = isShown ? showMessage : hideMessage;

			input.addEventListener("change", (e) => {
				if (!(e.target instanceof HTMLInputElement)) return;

				isShown = e.target.checked;
				label.innerHTML = isShown ? showMessage : hideMessage;
			});
		});

		const table = document.querySelector('table[height="4322"]');
		table?.parentElement?.replaceChild(divTable, table);
	}
}
